export default __webpack_public_path__ + "static/media/img24.d8626bf9.svg";